import { render, staticRenderFns } from "./designForm.vue?vue&type=template&id=d8a94ba4&"
import script from "./designForm.vue?vue&type=script&lang=js&"
export * from "./designForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports